<template>
  <div class="container--add-response--list">
    <el-row class="el-row--header" :gutter="24">
      <el-col :span="4">Дата погрузки</el-col>
      <el-col :span="4">ФИО</el-col>
      <el-col :span="4">Авто/прицеп</el-col>
      <el-col :span="6">Перевозчик</el-col>
      <el-col :span="3">Цена</el-col>
      <el-col :span="3">Добавить?</el-col>
    </el-row>
    <div v-if="responsesList.length">
      <el-row
        v-for="response in responsesList"
        :key="response.id"
        v-loading="!loadedAdd || !loadedResponsesNotAdded"
        class="el-row--item"
        :gutter="24"
        type="flex"
        align="middle"
      >
        <el-col :span="4">
          {{ dateToFormat(response['load-day'].load_date, 'shortDateWithoutYear') }}
        </el-col>
        <el-col :span="4">
          <column-short-fio :response-driver-fio="response.driver.fio" />
        </el-col>
        <el-col :span="4">
          <column-state-numbers :response-auto="response.auto" />
        </el-col>
        <el-col :span="6">
          <column-carrier :response-auto="response.auto" />
        </el-col>
        <el-col :span="3">
          <column-price :response="response" :type="type" />
        </el-col>
        <el-col :span="3">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-plus"
            class="is-circle"
            @click="clickAddResponse(response.id)"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ColumnCarrier from '@/views/LoadDay/Components/Responses/Columns/Carrier'
import ColumnPrice from '@/views/LoadDay/Components/Responses/Columns/Price'
import ColumnShortFio from '@/views/LoadDay/Components/Responses/Columns/ShortFIO'
import ColumnStateNumbers from '@/views/LoadDay/Components/Responses/Columns/StateNumbers'

import { ADD_RESPONSE_IN_REPORT } from '@/store/actions/reports'

export default {
  name: 'ResponsesList',
  components: {
    ColumnShortFio,
    ColumnStateNumbers,
    ColumnCarrier,
    ColumnPrice,
  },
  props: {
    responsesList: {
      type: Array,
      default: () => [],
    },
    reportId: {
      type: Number,
      default: null,
    },
    bidId: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      loadedAdd: 'reports/getLoadedAddResponse',
      loadedResponsesNotAdded: 'reports/getLoadedResponsesNotAdded',
    }),
  },
  methods: {
    clickAddResponse(responseId) {
      this.$store.dispatch(`reports/${ADD_RESPONSE_IN_REPORT}`, {
        responseId,
        reportId: this.reportId,
        bidId: this.bidId,
      })
    },
  },
}
</script>

<style lang="sass">
.container--add-response--list
  & .el-row--header
    text-align: center
    margin: 15px 0 10px
  & .el-row--item
    margin: 15px 0 15px 0
    background-color: #f9f9f9
    min-height: 80px
    & .el-col
      text-align: center
</style>
